export default "__VITE_ASSET__UELf8uwH__"